/**
 *  @directive sgOptionList
 *
 *  @param ngModel {Object} - The option list values
 **/

(function () {
  angular
    .module('specsguardApp')
    .component('sgOptionList', {
      require: {
        ngModelCtrl: 'ngModel'
      },
      bindings: {
        ngModel: '<'
      },
      templateUrl: 'app-legacy/components/sg-option-list/sg-option-list.tmpl.html',
      controller: 'sgOptionListCtrl as $sgOptionListCtrl'
    });
})();
